import { USER_ROLES } from '~/global/data/roles'

export default async function ({ redirect, store, route, error }) {
  const isSuper = store.getters['profile/isSuper']
  const allUserRolesIncludeHQ = store.getters['profile/allUserRolesIncludeHQ']
  const isAdministrator = store.getters['profile/isAdministrator']

  const pagePermissions = [].concat(
    ...route.matched.map((r) => {
      const permission = r.components.default.options
        ? r.components.default.options.permissions
        : r.components.default.permissions
      return permission || USER_ROLES.ALL
    })
  )
  let userCanAccessPage = false
  if (pagePermissions.includes(USER_ROLES.ALL) || !pagePermissions) {
    userCanAccessPage = true
  }
  // Check if user has permission access the page by check user permission is exist or not in list page permissions
  else if (allUserRolesIncludeHQ && allUserRolesIncludeHQ.length > 0) {
    userCanAccessPage = pagePermissions.some((permission) =>
      allUserRolesIncludeHQ.some((role) => role.name === permission)
    )
  }

  if (isAdministrator) userCanAccessPage = true

  if (!isSuper && route.path.split('/')[1] === 'admin') {
    userCanAccessPage = false
  }
  if (isSuper) {
    userCanAccessPage = true
  }

  // if can access page we will show error message
  if (!userCanAccessPage) {
    return error({
      statusCode: 403,
      message: `You don't have the permission to see this page.`,
    })
  }
}
